<section>
	<section class="row align-items-bottom header-box">
		<div class="col-20 text-bold text-align-left">
			<span dcrHTMLKey="VIEW_BLEND_TABLE_PORTFOLIO_HEADER"></span>
		</div>
		<div class="col-1 text-14-bold text-align-right margin-left-5">
			<span dcrHTMLKey="VIEW_BLEND_TABLE_WEIGHT_HEADER">Weight</span>
		</div>
	</section>

	<ng-container *ngIf="rootPortfolio?.childrenRef?.length">
		<ng-container *ngFor="let child of rootPortfolio.childrenRef; trackByFields: 'identifier'">
			<div class="row" [ngClass]="{ 'expandable-row': BlendPortfolioUtil.isChildPortfolio(child) }">
				<ac-blending-accordion class="col-24 margin-top-10" *ngIf="BlendPortfolioUtil.isChildPortfolio(child); else notAccordion">
					<ac-blending-accordion-panel
						[panelDepth]="1"
						[portfolioChild]="child"
						[inDialog]="true"
						[portChildrenMap]="portChildrenMap"
						[parentProjectedTotalAmount]="child.value"
						[isWeightActive]="true"
						[isEditable]="false"
					>
						<div class="col-17 text-16-bold">
							{{ child.description }}
							<div class="text-12 blackrock-model-label" *ngIf="BlendPortfolioUtil.isModel(child)">
								{{ MODEL_PORTFOLIO_TEXT }}
							</div>
						</div>
						<div class="col-2 text-16-bold text-align-right margin-left-35">{{ child.weight | number : '.0-2' }}%</div>
					</ac-blending-accordion-panel>
				</ac-blending-accordion>
			</div>

			<ng-template #notAccordion>
				<div class="col-1"></div>
				<div class="col-1 underline"></div>
				<div *ngIf="SECURITY_IDENTIFIERS.includes(child.identifierType)" class="col-2 text-bold">
					{{ child.ticker }}
				</div>

				<div class="col-14 text-bold">
					{{ child.description }}
				</div>

				<div *ngIf="!SECURITY_IDENTIFIERS.includes(child.identifierType)" class="col-2"></div>

				<div class="col-3 text-16-bold text-align-right margin-left-35">{{ child.weight | number : '.0-2' }}%</div>
				<div class="col-3"></div>
				<!-- </div> -->
			</ng-template>
		</ng-container>
	</ng-container>
</section>
